import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { useAppDispatch } from '@/hooks/redux';

import { setFinancialInfo } from '@/redux/user-data/actions';

import { FetchedFinancialInfo } from '@/types/finance';

import { getFinancialInfo } from '../api/finances';

export function useFinancialInfo() {
  const dispatch = useAppDispatch();
  const { data, isLoading } = useQuery<FetchedFinancialInfo[]>({
    queryKey: ['financial-info'],
    queryFn: getFinancialInfo,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (data) {
      dispatch(setFinancialInfo(data));
    }
  }, [data, dispatch]);

  return { data, isLoading };
}
